import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useVendorAuth } from "../store/vendorAuthStore";

const items = [
  { to: "/dashboard",    label: "Dashboard"   },
  { to: "/products",     label: "Products"    },
  { to: "/inventory",    label: "Inventory"   },
  { to: "/orders",       label: "Orders"      },
  { to: "/followers",    label: "Followers"   },
  { to: "/payouts",      label: "Payouts"     },
  { to: "/reviews",      label: "Reviews"     }, // ✅ Uncommented
  { to: "/profile/edit", label: "Edit Profile"},
];

export default function Sidebar() {
  const { vendor } = useVendorAuth();
  const [open, setOpen]       = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location              = useLocation();

  useEffect(() => {
    if (isMobile) setOpen(false);
  }, [location.pathname, isMobile]);

  useEffect(() => {
    const handler = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setOpen(false);
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  useEffect(() => {
    if (isMobile && open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => { document.body.style.overflow = "unset"; };
  }, [isMobile, open]);

  return (
    <>
      {/* ── Mobile top bar ── */}
      {isMobile && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0,
          height: 56, background: "#fff", borderBottom: "1px solid #eee",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "0 16px", zIndex: 300,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img src="logo.png" alt="Logo"
              style={{ width: 34, height: 34, borderRadius: 8, objectFit: "contain" }} />
            <span style={{ fontWeight: 900, fontSize: 15, color: "#111" }}>YURO SHOPY</span>
          </div>
          <button
            onClick={() => setOpen(p => !p)}
            style={{ background: "none", border: "none", cursor: "pointer", padding: 8, display: "flex", alignItems: "center", borderRadius: 8 }}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            {open ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="2.5" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
              </svg>
            )}
          </button>
        </div>
      )}

      {/* ── Mobile overlay ── */}
      {isMobile && open && (
        <div
          onClick={() => setOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 350, backdropFilter: "blur(2px)" }}
        />
      )}

      {/* ── Sidebar panel ── */}
      <aside style={isMobile ? {
        position: "fixed", top: 56, left: 0,
        width: 260, height: "calc(100vh - 56px)",
        background: "#fff", borderRight: "1px solid #eee",
        padding: 16, zIndex: 400, overflowY: "auto", boxSizing: "border-box",
        transform: open ? "translateX(0)" : "translateX(-100%)",
        transition: "transform 0.3s ease",
        boxShadow: open ? "4px 0 24px rgba(0,0,0,0.12)" : "none",
        display: "flex", flexDirection: "column",
      } : {
        width: 250, minWidth: 250, flexShrink: 0,
        background: "#fff", borderRight: "1px solid #eee",
        height: "100vh", padding: 16,
        position: "sticky", top: 0,
        zIndex: 100, boxSizing: "border-box",
        display: "flex", flexDirection: "column", overflowY: "auto",
      }}>

        {/* ── Brand ── */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 8px" }}>
          <img src="logo.png" alt="Logo" style={{
            width: 44, height: 44, borderRadius: 10,
            objectFit: "contain", border: "1px solid #f1f1f1",
          }} />
          <div>
            <div style={{ fontWeight: 900, fontSize: 15, color: "#111", letterSpacing: 0.5 }}>
              YURO SHOPY
            </div>
            <div style={{ fontSize: 12, color: "#777", marginTop: 3 }}>Vendor Panel</div>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#111", opacity: 0.85, marginTop: 4 }}>
              {vendor?.name || vendor?.shop_name || vendor?.owner_name || ""}
            </div>
          </div>
        </div>

        <div style={{ height: 1, background: "#eee", margin: "14px 0" }} />

        {/* ── Nav links ── */}
        <nav style={{ display: "flex", flexDirection: "column", gap: 8, flex: 1 }}>
          {items.map(x => (
            <NavLink
              key={x.to}
              to={x.to}
              onClick={() => { if (isMobile) setOpen(false); }}
              style={({ isActive }) => ({
                display: "block", padding: "12px 14px", borderRadius: 12,
                textDecoration: "none", fontWeight: 700, fontSize: 14,
                color:      isActive ? "#ff6a00" : "#111",
                background: isActive ? "#fdebe2" : "transparent",
                border:     isActive ? "1px solid #ffd1b6" : "1px solid transparent",
                transition: "0.15s", cursor: "pointer",
              })}
            >
              {x.label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}